import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreatePropertyPayload } from '../../types';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { createFormData } from '../helpers/createFormdata';
import { getApiErrorMessage, toApiError } from '../utils';

interface RequestUpdatePropertyParams {
	id: string;
	data: Partial<CreatePropertyPayload>;
}

export function useUpdateProperty() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation({
		mutationFn: async ({ id, data }: RequestUpdatePropertyParams) => {
			try {
				const formData = createFormData(data);
				return (await api.put(`/user/prop/update/${id}`, formData, {
					params: { forBinding },
				})).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar propriedade');
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['properties'] });
			queryClient.invalidateQueries({ queryKey: ['propertyId', variables.id] });
			queryClient.invalidateQueries({ queryKey: ['areas'] });
		},

		onError: (error) => {
			console.error(
				'Erro ao atualizar propriedade:',
				getApiErrorMessage(error, 'Erro ao atualizar propriedade')
			);
		},
	});
}
